// Deep-link capture for the catalog search.
//
// The in-app story CTA ("Go try it") links to /catalog?open_search=1 to land the
// user on the catalog with the search modal open. But the catalog pages rewrite
// the query string on mount (homepage URL-sync + ProductsList) and strip unknown
// params — this happens BEFORE the layout-level CatalogSearch component first
// renders, so reading the param inside the component is always too late.
//
// So we capture it once at app startup (called from src/index.js, before React
// renders anything, same as captureAttributionFromUrl) and hold it in this
// module. CatalogSearch consumes it on mount and opens the search modal.

let pending = false;

/** Call once at startup, before React renders. */
export function captureOpenSearchFromUrl() {
  if (typeof window === "undefined") return;
  try {
    if (new URLSearchParams(window.location.search).get("open_search") === "1") {
      pending = true;
    }
  } catch {
    // malformed URL — ignore
  }
}

/**
 * Pure read (no side effect) — safe to call from a useState initializer, which
 * React invokes twice under StrictMode in dev.
 */
export function peekOpenSearch() {
  return pending;
}

/**
 * Mark the deep-link as pending explicitly. Used for IN-APP (SPA) navigation
 * (e.g. the stories CTA) where the app isn't reloaded, so captureOpenSearchFromUrl
 * (which runs once at startup) never fires for the target URL.
 */
export function markOpenSearchPending() {
  pending = true;
}

/** Clear the flag so returning to the catalog later doesn't reopen the search. */
export function clearOpenSearch() {
  pending = false;
}
